import * as React from 'react'

import Svg, { Defs, G, Path, RadialGradient, Stop } from 'react-native-svg'

function DeliveryBox(props) {
  return (
    <Svg
      width={35}
      height={35}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G
        style={{
          mixBlendMode: 'luminosity',
        }}
      >
        <Path
          d="M32 23.263V8.738c0-.446-.27-.848-.681-1.019L16.422 1.554a1.102 1.102 0 00-.844 0L.682 7.72C.268 7.89 0 8.292 0 8.738v14.525c0 .446.269.849.681 1.02l14.897 6.163c.27.112.574.112.844 0l14.896-6.164c.413-.17.682-.573.682-1.02z"
          fill="url(#paint0_radial_1275_18033)"
        />
        <Path
          d="M.215 8.088L16 14.618l15.785-6.53a1.078 1.078 0 00-.47-.37L16.42 1.555a1.055 1.055 0 00-.839 0L.684 7.718c-.188.077-.35.205-.47.37z"
          fill="url(#paint1_radial_1275_18033)"
        />
        <Path
          d="M.215 8.088L16 14.618l15.785-6.53a1.078 1.078 0 00-.47-.37l-.104-.044c-2.505 1.054-12.45 5.22-14.748 5.727C14.3 13.88 4.55 9.075 1.34 7.448l-.656.27c-.188.076-.35.205-.47.37z"
          fill="#2E6ACA"
        />
        <Path
          d="M16 14.618v15.914a1.09 1.09 0 00.42-.089l14.896-6.162c.414-.17.684-.574.684-1.021V8.739c0-.234-.076-.462-.215-.65L16 14.619z"
          fill="url(#paint2_radial_1275_18033)"
        />
        <Path
          d="M16 14.618v15.914a1.09 1.09 0 00.42-.089l.6-.25c-.232-2.935-.828-11.636.082-13.92.973-2.43 12.26-6.585 14.898-7.523v-.011c0-.234-.076-.462-.215-.65L16 14.619z"
          fill="#2E6ACA"
        />
        <Path
          d="M16 14.611v15.912a1.09 1.09 0 01-.42-.088l-.6-.25c.232-2.936.828-11.636-.082-13.92C13.925 13.834 2.638 9.679 0 8.74v-.01c0-.235.075-.463.215-.65L16 14.61z"
          fill="#4283EC"
        />
        <Path
          d="M6.665 5.24l14.77 7.134 3.923-1.627-14.765-7.128L6.665 5.24z"
          fill="url(#paint3_radial_1275_18033)"
        />
        <Path
          d="M20.607 11.977l.822.397h.006l3.923-1.627-.734-.353a221.757 221.757 0 01-4.017 1.583z"
          fill="#CE9B5C"
        />
        <Path
          d="M21.517 12.336v6.413a.55.55 0 00.77.507l2.758-1.182a.55.55 0 00.334-.507V10.74l-3.862 1.595z"
          fill="url(#paint4_radial_1275_18033)"
        />
        <Path
          d="M21.517 12.336v.75a65.772 65.772 0 013.862-1.766v-.579l-3.862 1.595z"
          fill="#CE9B5C"
        />
        <Path
          d="M19.31 24.551c.07 0 .14-.013.205-.04l2.759-1.103a.551.551 0 10-.41-1.025l-2.758 1.104a.55.55 0 00.205 1.064z"
          fill="url(#paint5_radial_1275_18033)"
        />
        <Path
          d="M19.31 27.31c.07 0 .14-.013.205-.04l5.518-2.207a.552.552 0 10-.41-1.024l-5.517 2.207a.55.55 0 00.205 1.064z"
          fill="url(#paint6_radial_1275_18033)"
        />
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_1275_18033"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-15.11038 20.40114 -12.7297 -9.42842 20.855 7.788)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_1275_18033"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-14.90727 9.23174 -5.391 -8.7053 20.79 4.327)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_1275_18033"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-7.55504 15.75589 -8.01386 -3.8427 26.427 12.968)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint3_radial_1275_18033"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(146.232 8.037 4.977) scale(13.8551 14.4783)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <RadialGradient
          id="paint4_radial_1275_18033"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(107.542 7.573 14.574) scale(7.89629 5.13215)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <RadialGradient
          id="paint5_radial_1275_18033"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(140.853 6.477 15.033) scale(3.07568 3.4056)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
        <RadialGradient
          id="paint6_radial_1275_18033"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-4.08433 2.91193 -3.11288 -4.36619 22.588 24.388)"
        >
          <Stop stopColor="#FFEED8" />
          <Stop offset={1} stopColor="#D59A4F" />
        </RadialGradient>
      </Defs>
    </Svg>
  )
}

export default DeliveryBox
